import type { ReactNode } from 'react'

type BadgeVariant = 'default' | 'ok' | 'warn' | 'err' | 'accent' | 'info'

interface BadgeProps {
  children: ReactNode
  v?: BadgeVariant
  dot?: boolean
  sm?: boolean
}

const VARIANT_MAP: Record<BadgeVariant, { bg: string; c: string }> = {
  default: { bg: 'var(--bg-4)', c: 'var(--text-2)' },
  ok: { bg: 'var(--ok-m)', c: 'var(--ok)' },
  warn: { bg: 'var(--warn-m)', c: 'var(--warn)' },
  err: { bg: 'var(--err-m)', c: 'var(--err)' },
  accent: { bg: 'var(--accent-m)', c: 'var(--accent)' },
  info: { bg: 'var(--info-m)', c: 'var(--info)' },
}

export function Badge({ children, v = 'default', dot, sm }: BadgeProps) {
  const s = VARIANT_MAP[v] || VARIANT_MAP.default
  return (
    <span
      style={{
        background: s.bg,
        color: s.c,
        padding: sm ? '1px 6px' : '2px 10px',
        borderRadius: 'var(--r-f)',
        fontSize: sm ? 9 : 11,
        fontWeight: 600,
        fontFamily: 'var(--font)',
        letterSpacing: '.02em',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        lineHeight: sm ? '14px' : '18px',
      }}
    >
      {dot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: s.c,
            animation: v === 'ok' ? 'pulse-soft 2s infinite' : 'none',
          }}
        />
      )}
      {children}
    </span>
  )
}
